import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=cbb726b4&scoped=true&"
import script from "./Area.vue?vue&type=script&lang=js&"
export * from "./Area.vue?vue&type=script&lang=js&"
import style0 from "./Area.vue?vue&type=style&index=0&id=cbb726b4&lang=scss&scoped=true&"
import style1 from "./Area.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb726b4",
  null
  
)

export default component.exports